import * as angular from 'angular';

const fdHelpDialogHtml = require('../../views/fd_help_dialog.html');

'use strict';

angular.module('formApp').directive('fdHelpDialog', function () {
  return {
    templateUrl: fdHelpDialogHtml,
    scope: {
      helpDialog: '=',
      displayHelpDialog: '='
    },
    controller: 'fdHelpDialogCtrl',
    replace: true
  };
});
